import React, { useRef } from 'react'
import Slider from 'react-slick'
import { useTranslation } from 'next-i18next'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const items = (t) => [
    {
        id: "1",
        title: t("methodology-page.hero-slide-column-title-1"),
        text: t("methodology-page.hero-slide-column-subtitle-1")
    },
    {
        id: "2",
        title: t("methodology-page.hero-slide-column-title-2"),
        text: t("methodology-page.hero-slide-column-subtitle-2")
    },
    {
        id: "3",
        title: t("methodology-page.hero-slide-column-title-3"),
        text: t("methodology-page.hero-slide-column-subtitle-3")
    },
    {
        id: "4",
        title: t("methodology-page.hero-slide-column-title-4"),
        text: t("methodology-page.hero-slide-column-subtitle-4")
    },
    {
        id: "5",
        title: t("methodology-page.hero-slide-column-title-5"),
        text: t("methodology-page.hero-slide-column-subtitle-5")
    },
    {
        id: "6",
        title: t("methodology-page.hero-slide-column-title-6"),
        text: t("methodology-page.hero-slide-column-subtitle-6")
    },
    {
        id: "7",
        title: t("methodology-page.hero-slide-column-title-7"),
        text: t("methodology-page.hero-slide-column-subtitle-7")
    }
]

const CourseMeetings = () => {
    const { t } = useTranslation()
    const sliderRef = useRef(null)
    const topRowItems = items(t).slice(0, 3)
    const bottomRowItems = items(t).slice(3, 7)

    const autoplaySpeed = 3000

    const sliderSettings = {
        dots: false,
        infinite: false,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        variableWidth: false,
        autoplaySpeed: autoplaySpeed,
        centerMode: false,
        centerPadding: '0px',
        afterChange: (current) => {
            if (current === items.length - 1) {
                setTimeout(() => {
                    if (sliderRef.current) {
                        sliderRef.current.slickGoTo(0, false)
                    }
                }, autoplaySpeed)
            }
        }
    }

    const Card = ({ item, isTopRow, isLastInRow, roundedClasses, isSlider = false }) => {
        const borderClasses = isTopRow
            ? `border-t-[1px] border-l-[1px] border-b-[1px] ${isLastInRow ? 'border-r-[1px]' : ''}`
            : `border-l-[1px] border-b-[1px] ${isLastInRow ? 'border-r-[1px]' : ''}`

        const cardClasses = isSlider
            ? 'relative border-[1px] border-[#444] px-[24px] py-[40px] bg-white rounded-[12px] w-full max-w-[calc(100vw-80px)] sm:max-w-[300px] mx-auto h-[550px] xs:h-[450px]'
            : `relative ${borderClasses} border-[#444] px-[24px] py-[40px] bg-white ${roundedClasses}`

        return (
            <div className={cardClasses}>
                <span className="absolute -top-6 right-5 w-[70px] h-[52px] flex items-center justify-center bg-[linear-gradient(180deg,#091F59_0%,#1A3884_100%)] text-white text-[30px] font-[500] px-4 rounded-[8px]">
                    0<span className="text-main-pink">{item.id}</span>
                </span>
                <h3 className="bg-clip-text text-transparent bg-gradient-to-b from-[#091F59] to-[#1A3884] text-[20px] mb-[20px] font-[500]">
                    {item.title}
                </h3>
                <p className="text-[#8B8B8B] text-[14px] lg:text-[16px] leading-relaxed">{item.text}</p>
            </div>
        )
    }

    return (
        <div className="max-w-[90%] mx-auto mb-[80px] lg:mb-[200px]">
            <h2 className="text-[32px] md:text-[48px] lg:text-[64px] xl:text-[80px] font-[500] leading-tight text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884] mb-[40px] lg:mb-[120px] text-center lg:text-left">
                {t("methodology-page.hero-slide-main-title-1")}
            </h2>
            <div className="bg-white rounded-[25px]">
                <div className="block lg:hidden px-4 py-8 overflow-hidden">
                    <Slider ref={sliderRef} {...sliderSettings}>
                        {items(t).map((item) => (
                            <div key={item.id} className="focus:outline-none">
                                <Card item={item} isSlider={true} />
                            </div>
                        ))}
                    </Slider>
                </div>

                <div className="hidden lg:block">
                    <div className="grid lg:grid-cols-3">
                        {topRowItems.map((item, index) => (
                            <Card
                                key={item.id}
                                item={item}
                                isTopRow={true}
                                isLastInRow={index === 2}
                                roundedClasses={item.id === '1' ? 'rounded-tl-[24px]' : item.id === '3' ? 'rounded-tr-[24px]' : ''}
                            />
                        ))}
                    </div>
                    <div className="grid lg:grid-cols-4">
                        {bottomRowItems.map((item, index) => (
                            <Card
                                key={item.id}
                                item={item}
                                isTopRow={false}
                                isLastInRow={index === 3}
                                roundedClasses={item.id === '4' ? 'rounded-bl-[24px]' : item.id === '7' ? 'rounded-br-[24px]' : ''}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CourseMeetings
